import React, { useState, useEffect, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from "react-qr-code";

const EventPDFModal = ({ isOpen, onClose, data, inviteQr }) => {
  const [isLoading, setIsLoading] = useState(false);
  const pdfRef = useRef();

  const handleDownloadPDF = async () => {
    setIsLoading(true);
    const elements = pdfRef.current.children;
    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const canvas = await html2canvas(element, { useCORS: true, scale: 2 });
      const dataURL = canvas.toDataURL("image/png");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(dataURL, "PNG", 0, 0, imgWidth, imgHeight);
    }

    pdf.save("THIỆP MỜI BCCU.pdf");
    setIsLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-base-100 p-0 lg:p-6 rounded-lg w-5/6 lg:w-3/4 max-h-[90vh] overflow-y-auto">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-end mb-10">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 btn btn-outline rounded btn-sm  mt-3"
            >
              X
            </button>
          </div>

          <div className="space-y-5" ref={pdfRef}>
            <div className="relative w-full max-w-2xl mx-auto">
              <img
                src="/template_background_bccu.png"
                alt="Background"
                className="w-full h-auto object-cover"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-center text-white text-base md:text-xl">
                <div className="px-2 lg:px-4 w-full py-24 pb-12 lg:py-56 lg:pb-28 flex flex-col h-full">
                  <div className="flex flex-col items-center uppercase font-bold text-[10px] lg:text-[18px] leading-normal">
                    <p>Chương trình</p>
                    <p className="mb-2 lg:mb-5">{data?.title}</p>
                    <p>Chủ đề</p>
                    <p className="text-center">{data?.topic}</p>
                  </div>
                  <div className="flex flex-col justify-between text-[10px] lg:text-[14px] flex-grow">
                    <div className="flex py-5 lg:py-10 flex-grow gap-3 lg:gap-5">
                      <div className="flex-[1] lg:flex-1 flex flex-col space-y-1 lg:space-y-5">
                        <div>
                          Thời gian:
                          <br />
                          <span className="font-bold">{data?.time}</span>
                        </div>

                        <div>
                          <span>Địa điểm:</span>
                          <br />
                          <div className="flow-root">
                            <div className="sun-editor-editable">
                              <span
                                className="font-bold"
                                dangerouslySetInnerHTML={{
                                  __html: data?.location,
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <div className="flow-root">
                            <div className="sun-editor-editable">
                              <span
                                className="text-white"
                                dangerouslySetInnerHTML={{
                                  __html: data?.note,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="flex-[2] lg:flex-1 rounded-[30px] p-2 lg:p-4 bg-white border-orange-400 border-2 lg:border-4">
                        <div className="flex justify-center text-blue-500 font-bold uppercase">
                          Nội dung chương trình
                        </div>
                        <div className="mt-1 lg:mt-5 space-y-3 text-[8px] lg:text-[12px]">
                          {JSON.parse(data?.content ?? "[]").map(
                            (item, idx) => (
                              <div
                                className="flex justify-between text-base-300 font-bold gap-5"
                                key={idx}
                              >
                                <p className="text-blue-500 flex-[2]">
                                  {item.time}
                                </p>
                                <p className="flex-[4] text-blue-500">
                                  {item.value}
                                </p>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-3 lg:gap-8 justify-center ml-3 lg:ml-10">
                      <img
                        src={data?.qrCode}
                        // src={
                        //   "https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg"
                        // }
                        alt=""
                        className="h-10 w-10 lg:h-24 lg:w-24 bg-white"
                      />

                      <div className="h-10 w-10 lg:h-24 lg:w-24 bg-white flex justify-center items-center">
                        <QRCode value={inviteQr} size={75} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end space-x-4 mt-10">
            <button
              disabled={isLoading}
              type="button"
              onClick={handleDownloadPDF}
              className="px-4 py-2 btn btn-outline rounded btn-sm btn-success"
            >
              {isLoading ? "Đang xử lý ..." : "Xuất PDF"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventPDFModal;
